/**
 * Seating Map - LA 2028 Summer Games (block-level, generated maps from googleadsGT/scripts/la28/maps)
 *
 * Map markup: <div class="la28-map" data-venue data-product-cats="F,G"> <svg class="la28-svg">
 *   <g class="sec" data-sec="b1" data-name="Category B" data-categories="B" data-category="B"> ... </g>
 * Older markup (one <g data-category="X"> per category, no .sec) still works: every [data-category] group is a target.
 *
 * Behaviour:
 * - Categories this product sells (data-product-cats, from the variant titles) stay in full colour; the others are
 *   dimmed. Legend items of sold categories show "from $X" (lowest card price for that category).
 * - Hover / focus a block: the block is outlined and a tooltip shows "Category X", the price and the block name.
 * - Click / tap a block or a legend item: that category is focused on the map and its ticket cards are highlighted
 *   (and scrolled into view on small screens). Clicking it again, or outside the map, returns to the default state.
 */
(function () {
  'use strict';

  function formatMapPrice(dollars) {
    if (window.CurrencyConverter && window.CurrencyConverter.isEurMode && window.CurrencyConverter.isEurMode()) {
      return window.CurrencyConverter.convertDollars(dollars);
    }
    return '$' + Math.round(dollars).toLocaleString('en-US');
  }

  function init() {
    var map = document.querySelector('.la28-map');
    if (!map) return;
    var svg = map.querySelector('.la28-svg');
    if (!svg) return;

    var tooltip = map.querySelector('.map-tooltip');
    var legendItems = Array.prototype.slice.call(document.querySelectorAll('.la28-legend-item'));

    // targets: block-level groups when present, else the legacy per-category groups
    var targets = Array.prototype.slice.call(svg.querySelectorAll('.sec[data-category]'));
    if (!targets.length) {
      targets = Array.prototype.slice.call(svg.querySelectorAll('[data-category]')).filter(function (g) {
        var c = g.getAttribute('data-category');
        return c && c !== 'none' && c !== 'field';
      });
    }
    if (!targets.length) return;

    function catsOf(el) {
      var list = (el.getAttribute('data-categories') || el.getAttribute('data-category') || '').toUpperCase();
      return list.split(/[,\s]+/).filter(Boolean);
    }

    // ticket cards in the right-hand column (fall back to any card on the page)
    var cardRoot = document.querySelector('.la28-tickets-col') || document;
    var cards = Array.prototype.slice.call(cardRoot.querySelectorAll('.ticket-variant-card'));
    function cardCat(card) {
      var c = (card.getAttribute('data-category') || '').toUpperCase();
      var m = c.match(/([A-Z])$/);
      return m ? m[1] : '';
    }
    var priceByCat = {};
    cards.forEach(function (card) {
      var c = cardCat(card);
      var cents = parseFloat(card.getAttribute('data-price'));
      if (!c || isNaN(cents)) return;
      priceByCat[c] = Math.min(priceByCat[c] === undefined ? Infinity : priceByCat[c], cents / 100);
    });

    var sold = (map.getAttribute('data-product-cats') || '').toUpperCase().split(/[,\s]+/).filter(Boolean);
    Object.keys(priceByCat).forEach(function (c) { if (sold.indexOf(c) < 0) sold.push(c); });
    var present = {};
    targets.forEach(function (g) { catsOf(g).forEach(function (c) { present[c] = true; }); });
    var hasSold = sold.some(function (c) { return present[c]; });

    var focusedCat = null;

    function isSold(c) { return sold.indexOf(c) >= 0; }

    function applyState() {
      targets.forEach(function (g) {
        var cs = catsOf(g);
        g.classList.remove('la28-your-cat', 'la28-dim', 'la28-active');
        if (focusedCat) {
          g.classList.add(cs.indexOf(focusedCat) >= 0 ? 'la28-active' : 'la28-dim');
        } else if (hasSold) {
          if (!cs.some(isSold)) g.classList.add('la28-dim');
        }
      });
      legendItems.forEach(function (item) {
        var c = (item.getAttribute('data-cat') || '').toUpperCase();
        item.classList.toggle('active', focusedCat ? c === focusedCat : false);
        item.classList.toggle('la28-legend-sold', isSold(c));
      });
      cards.forEach(function (card) {
        card.classList.toggle('la28-card-hl', !!focusedCat && cardCat(card) === focusedCat);
      });
    }

    // legend: "from $X" for categories with tickets on this page
    function renderLegendPrices() {
      legendItems.forEach(function (item) {
        var c = (item.getAttribute('data-cat') || '').toUpperCase();
        var old = item.querySelector('.la28-from');
        if (old) old.parentNode.removeChild(old);
        if (priceByCat[c] === undefined || !isFinite(priceByCat[c])) return;
        var s = document.createElement('span');
        s.className = 'la28-from';
        s.textContent = 'from ' + formatMapPrice(priceByCat[c]);
        item.appendChild(s);
      });
    }

    // ===== Tooltip =====
    function tooltipHtml(g) {
      var cs = catsOf(g);
      var c = cs[0];
      var html = '<strong>Category ' + cs.join(' / ') + '</strong>';
      // block name without the repeated "Category X, " prefix, e.g. "Upper tier, top side"
      var name = (g.getAttribute('data-name') || '').replace(/^Category [A-Z](\/[A-Z])*,?\s*/, '');
      if (name) html += '<br>' + name.charAt(0).toUpperCase() + name.slice(1);
      if (priceByCat[c] !== undefined && isFinite(priceByCat[c])) {
        html += '<br><span class="tooltip-price">From ' + formatMapPrice(priceByCat[c]) + '</span>';
      } else if (hasSold) {
        html += '<br><span class="tooltip-note">No tickets listed in this category</span>';
      }
      return html;
    }
    function showTooltipAt(g, x, y) {
      if (!tooltip) return;
      tooltip.innerHTML = tooltipHtml(g);
      tooltip.classList.add('visible');
      tooltip.style.left = x + 'px';
      tooltip.style.top = y - 56 + 'px';
    }
    function showForEvent(g, e) {
      var r = map.getBoundingClientRect();
      showTooltipAt(g, e.clientX - r.left, e.clientY - r.top);
    }
    function showForElement(g) {
      var r = map.getBoundingClientRect();
      var b = g.getBoundingClientRect();
      showTooltipAt(g, b.left + b.width / 2 - r.left, b.top - r.top);
    }
    function hideTooltip() {
      if (tooltip) tooltip.classList.remove('visible');
    }

    // ===== Focus =====
    function scrollToCards(cat) {
      if (!window.matchMedia || !window.matchMedia('(max-width: 989px)').matches) return;
      var first = null;
      cards.forEach(function (card) { if (!first && cardCat(card) === cat) first = card; });
      if (first && first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function toggleFocus(cat, fromUser) {
      focusedCat = focusedCat === cat ? null : cat;
      applyState();
      if (focusedCat && fromUser) scrollToCards(focusedCat);
    }
    function clearFocus() {
      if (focusedCat === null) return;
      focusedCat = null;
      applyState();
    }

    // ===== Bind blocks =====
    targets.forEach(function (g) {
      var cat = catsOf(g)[0];
      g.setAttribute('tabindex', '0');
      g.setAttribute('role', 'button');
      g.setAttribute('aria-label', (g.getAttribute('data-name') || ('Category ' + cat)) +
        (priceByCat[cat] !== undefined && isFinite(priceByCat[cat]) ? ', from ' + formatMapPrice(priceByCat[cat]) : ''));
      g.addEventListener('mouseenter', function (e) { g.classList.add('la28-hot'); showForEvent(g, e); });
      g.addEventListener('mousemove', function (e) { showForEvent(g, e); });
      g.addEventListener('mouseleave', function () { g.classList.remove('la28-hot'); hideTooltip(); });
      g.addEventListener('focus', function () { showForElement(g); });
      g.addEventListener('blur', hideTooltip);
      g.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleFocus(cat, true);
        if (window.matchMedia && window.matchMedia('(hover: none)').matches) showForElement(g);
      });
      g.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleFocus(cat, true);
        }
      });
    });

    // ===== Bind legend =====
    legendItems.forEach(function (item) {
      var cat = (item.getAttribute('data-cat') || '').toUpperCase();
      if (!cat) return;
      item.setAttribute('tabindex', '0');
      item.setAttribute('role', 'button');
      var activate = function (e) {
        if (e) e.stopPropagation();
        toggleFocus(cat, true);
      };
      item.addEventListener('click', activate);
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.la28-map') && !e.target.closest('.la28-legend-item')) {
        clearFocus();
        hideTooltip();
      }
    });
    document.addEventListener('currency:ready', renderLegendPrices);

    renderLegendPrices();
    applyState();
    map.setAttribute('data-ready', '1');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
